import { render, staticRenderFns } from "./dealConfirmGetDetail.vue?vue&type=template&id=1a046bd5&scoped=true&"
import script from "./dealConfirmGetDetail.vue?vue&type=script&lang=js&"
export * from "./dealConfirmGetDetail.vue?vue&type=script&lang=js&"
import style0 from "./dealConfirmGetDetail.vue?vue&type=style&index=0&id=1a046bd5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a046bd5",
  null
  
)

export default component.exports